var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c(
      "div",
      { staticClass: "pl-20 pt-20 pr-20 panel-group bg-white " },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: _vm.device === "mobile" ? 10 : 20 } },
          [
            _vm.checkRoles(["partner"]) && _vm.checkHidRole("homeYjtj")
              ? _c(
                  "el-col",
                  {
                    staticClass: "card-panel-col ",
                    attrs: { xs: 12, sm: 12, lg: 4 },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadingStates.deposit,
                            expression: "loadingStates.deposit",
                          },
                        ],
                        staticClass: "border-r6 border",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: "/home/agentDeposit?callPages=panelGroup",
                                })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "fs-c1" }, [
                              _c("b", [_vm._v("存量额")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "fs-s4 text-grey cursor" },
                              [
                                _vm._v("更多"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-right el-icon--right",
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "box " }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                            },
                            [
                              _c("span", { staticClass: "group-tag " }, [
                                _vm._v("今日存量额"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "today-num fs-b2" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.todayData.today_cdb_user_balance ||
                                        "--"
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                            },
                            [
                              _c("span", { staticClass: "group-tag " }, [
                                _vm._v("昨日存量额"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "today-num fs-b2" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.yesterdayData
                                        .yesterday_cdb_user_balance || "--"
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                            },
                            [
                              _c("span", { staticClass: "fs-s5 " }, [
                                _vm._v("环比"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex justify-end fs-b2 " },
                                [
                                  _c("span", { staticClass: "fs-s5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.todayRatioData
                                          .ratio_cdb_user_balance || "--"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "card-panel-col ",
                attrs: { xs: 12, sm: 12, lg: 4 },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStates.turnover,
                        expression: "loadingStates.turnover",
                      },
                    ],
                    staticClass: "border-r6 border",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              path: "/home/dayMoney?callPages=panelGroup",
                            })
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fs-c1" }, [
                          _c("b", [_vm._v("交易额")]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fs-s4 text-grey cursor" }, [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "box " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("今日交易额"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.todayData.today_order_amount || "--")
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("昨日交易额"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.yesterdayData.yesterday_order_amount ||
                                    "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                        },
                        [
                          _c("span", { staticClass: "fs-s5 " }, [
                            _vm._v("环比"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end fs-b2 " },
                            [
                              _c("span", { staticClass: "fs-s5" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.todayRatioData.ratio_order_amount ||
                                      "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "card-panel-col ",
                attrs: { xs: 12, sm: 12, lg: 4 },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStates.order,
                        expression: "loadingStates.order",
                      },
                    ],
                    staticClass: "border-r6 border",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                        on: {
                          click: function ($event) {
                            _vm.$router.push({
                              path:
                                "" +
                                (_vm.checkRoles(["terminal"])
                                  ? "/order/subOrder?callPages=panelGroup"
                                  : "/order/meOrder?callPages=panelGroup"),
                            })
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fs-c1" }, [
                          _c("b", [_vm._v("订单数")]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fs-s4 text-grey cursor" }, [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "box " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("今日订单"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.todayData.today_order_num || "--")
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("昨日订单"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.yesterdayData.yesterday_order_num || "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                        },
                        [
                          _c("span", { staticClass: "fs-s5 " }, [
                            _vm._v("环比"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end fs-b2 " },
                            [
                              _c("span", { staticClass: "fs-s5" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.todayRatioData.ratio_order_num || "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "card-panel-col ",
                attrs: { xs: 12, sm: 12, lg: 4 },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStates.user,
                        expression: "loadingStates.user",
                      },
                    ],
                    staticClass: "border-r6 border",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                        on: {
                          click: function ($event) {
                            _vm.$router.push({
                              path: _vm.checkRoles(["terminal", "partner"])
                                ? "/userManage/userList?callPages=panelGroup"
                                : "",
                            })
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fs-c1" }, [
                          _c("b", [_vm._v("用户数")]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fs-s4 text-grey cursor" }, [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "box " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("今日新增户"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.todayData.today_order_user_num || "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("昨日新增户"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.yesterdayData.yesterday_order_user_num ||
                                    "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                        },
                        [
                          _c("span", { staticClass: "fs-s5 " }, [
                            _vm._v("环比"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end fs-b2 " },
                            [
                              _c("span", { staticClass: "fs-s5" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.todayRatioData.ratio_order_user_num ||
                                      "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "card-panel-col ",
                attrs: { xs: 12, sm: 12, lg: 4 },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStates.withdrawal,
                        expression: "loadingStates.withdrawal",
                      },
                    ],
                    staticClass: "border-r6 border",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                        on: {
                          click: function ($event) {
                            _vm.$router.push({
                              path: _vm.checkRoles(["terminal", "partner"])
                                ? "/withdraw/reviewe?callPages=panelGroup"
                                : "",
                            })
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fs-c1" }, [
                          _c("b", [_vm._v("提现额")]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cursor fs-s4 text-grey" }, [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "box " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("今日提现"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.todayData.today_withdrawing_money || "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("昨日提现"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.yesterdayData
                                    .yesterday_withdrawing_money || "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                        },
                        [
                          _c("span", { staticClass: "fs-s5 " }, [
                            _vm._v("环比"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end fs-b2 " },
                            [
                              _c("span", { staticClass: "fs-s5" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.todayRatioData
                                      .ratio_withdrawing_money || "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-col",
              {
                staticClass: "card-panel-col ",
                attrs: { xs: 12, sm: 12, lg: 4 },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingStates.profit,
                        expression: "loadingStates.profit",
                      },
                    ],
                    staticClass: "border-r6 border",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flexh-between-center p-10 bg-f8 pl-10 pr-5 pt-15 pb-15 border-b",
                        on: {
                          click: function ($event) {
                            return _vm.shopRevieweShowDialog()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "fs-c1" }, [
                          _c("b", [_vm._v("分成额")]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cursor fs-s4 text-grey" }, [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "box " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("今日分成"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.todayData.today_profit || "--")
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center pl-5 pt-10 pb-10 pr-10 ",
                        },
                        [
                          _c("span", { staticClass: "group-tag " }, [
                            _vm._v("昨日分成"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "today-num fs-b2" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.yesterdayData.yesterday_profit || "--"
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flexh-between-center text-grey pl-10 pr-10 pt-15 pb-15",
                        },
                        [
                          _c("span", { staticClass: "fs-s5 " }, [
                            _vm._v("环比"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end fs-b2 " },
                            [
                              _c("span", { staticClass: "fs-s5" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.todayRatioData.ratio_profit || "--"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            attrs: {
              title: "分成额总览",
              visible: _vm.shopOverviewDialogVisible,
              width: "1200px",
              "before-close": _vm.handleShopOrderStatsClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.shopOverviewDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.shopOverviewLoading,
                    expression: "shopOverviewLoading",
                  },
                ],
              },
              [
                _c(
                  "div",
                  { staticClass: "filter-container mb-10" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.fetchShopOverviewData },
                        model: {
                          value: _vm.shopOverviewTimeRange,
                          callback: function ($$v) {
                            _vm.shopOverviewTimeRange = $$v
                          },
                          expression: "shopOverviewTimeRange",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: "today" } }, [
                          _vm._v("今日"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "month" } }, [
                          _vm._v("本月"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio-button",
                          { attrs: { label: "last_month" } },
                          [_vm._v("上月")]
                        ),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "quarter" } }, [
                          _vm._v("季度(近90天)"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: "year" } }, [
                          _vm._v("年度(近一年)"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticClass: "ml-20",
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd",
                      },
                      on: { change: _vm.handleDateRangeChange },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "total-amount ml-20 text-right" }, [
                  _c("span", { staticClass: "large-font" }, [_vm._v("合计：")]),
                  _c("span", { staticClass: "amount-value large-font" }, [
                    _vm._v("¥" + _vm._s(_vm.totalDeviceTypeAmount)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chart-container" }, [
                  _c("div", {
                    ref: "deviceTypeChartContainer",
                    staticStyle: {
                      width: "100%",
                      height: "400px",
                      "margin-bottom": "20px",
                    },
                  }),
                  _vm._v(" "),
                  _vm.deviceTypeChartLoading
                    ? _c("div", { staticClass: "loading-overlay" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("加载中...")]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-container mb-10" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.handleDeviceTypeChange },
                        model: {
                          value: _vm.shopOverviewDeviceType,
                          callback: function ($$v) {
                            _vm.shopOverviewDeviceType = $$v
                          },
                          expression: "shopOverviewDeviceType",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 5 } }, [
                          _vm._v("充电桩"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 3 } }, [
                          _vm._v("充电线"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("充电宝"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 9 } }, [
                          _vm._v("套套机"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("其他"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "total-amount ml-20 text-right" }, [
                  _c("span", { staticClass: "large-font" }, [_vm._v("合计：")]),
                  _c("span", { staticClass: "amount-value large-font" }, [
                    _vm._v("¥" + _vm._s(_vm.shopOverviewData.total_amount)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "chart-container" }, [
                  _c("div", {
                    ref: "shopChartContainer",
                    staticStyle: { width: "100%", height: "400px" },
                  }),
                  _vm._v(" "),
                  _vm.shopChartLoading
                    ? _c("div", { staticClass: "loading-overlay" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("加载中...")]),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-card",
              { staticClass: "explanation-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("统计说明"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "explanation-content" }, [
                  _c("p", [
                    _c("strong", [_vm._v("平台分佣：")]),
                    _vm._v("聚合"),
                    _c("code", [_vm._v("xs_admin_user_account_log")]),
                    _vm._v(
                      "数据库且收益来源字段中带有‘充电桩’、‘套套机’、‘密码线’、‘充电宝’和‘底座’关键字的归类为平台的分佣。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("手续费：")]),
                    _vm._v("聚合"),
                    _c("code", [_vm._v("xs_admin_user_account_log")]),
                    _vm._v(
                      "数据库且收益来源字段中带有‘手续费’关键字的归类为手续费的收入。"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("strong", [_vm._v("增值分佣：")]),
                    _vm._v(
                      "漏单的、隐藏的、已支付的、没有发生退款的、有实际支付的"
                    ),
                    _c("code", [_vm._v("money_paid")]),
                    _vm._v("数据总和。"),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.shopOverviewDialogVisible = false
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tit mb-15 " }, [
      _c("b", { staticClass: "flex1 fs-a1" }, [
        _c("span", { staticClass: "lin" }),
        _vm._v("数据总览"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }